import React from 'react'
import styled from 'styled-components'
import Grid, {GridProps} from '@mui/material/Grid'
import gridStyles from './grid.styles'

interface ApGridProps extends GridProps {
  ap_type?:
    | 'gridAccordionTitle'
    | 'gridAccordionDetails'
    | 'gridAccordionDetailsWrapper'
    | 'itemsLeft'
    | 'itemsRight'
    | 'itemsMiddle'
  ap_display?: 'none'
}

const apGridCAtomName = {ap_atom_name: 'gridContainerAtom'}

export const GridContainerAtom = styled((props: ApGridProps) => (
  <Grid container {...apGridCAtomName} {...props} spacing={2} />
))`
  ${gridStyles}
`

const apGridIAtomName = {ap_atom_name: 'gridItemAtom'}

export const GridItemAtom = styled((props: ApGridProps) => (
  <Grid item {...apGridIAtomName} {...props} />
))`
  ${gridStyles}
`
